module.exports = __webpack_public_path__ + "img/26.7ef28ebc.jpg";